import { InternalError } from '@fragment/error-utils';
import type { LedgerAccountType } from '@fragment/types';
import type { TxType } from '@fragment/types/tx';

export const abs = (n: bigint): bigint => (n < 0 ? -n : n);

export const getCreditOrDebit = (
  ledgerAccountType: LedgerAccountType,
  line: { amount: bigint }
): TxType => {
  if (ledgerAccountType === 'asset' || ledgerAccountType === 'expense') {
    // debit normal
    if (line.amount < 0) {
      return 'credit';
    }
    return 'debit';
  }
  if (ledgerAccountType === 'liability' || ledgerAccountType === 'income') {
    // credit normal
    if (line.amount < 0) {
      return 'debit';
    }
    return 'credit';
  }
  throw new InternalError(`Invalid ledger account type: ${ledgerAccountType}`);
};
